export const PASSWORD_POLICY_REGEX = /^(?=.*[A-Z])(?=.*[!@%#$&])(?=.*[0-9])(?=.*[a-z]).{14,64}$/;
